export const ALREADY_VOTED_WARNING_MESSAGE = 'Beklager, ditt medlemsnummer er allerede benyttet ved årets Coop Valg.';

export const UNDERAGE_WARNING_MESSAGE =
    'Beklager, men du kan ikke stemme ved dette valget da du er under myndighetsalder.';
